import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import approval from "../../../containers/modules/user/approval";
import Download from "../../../components/modules/user/download";

export default function DownloadRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="download"
      index
      element={
        <AccessControl
          name={"Download Apps"}
          auth={authUser}
          component={Download}
        />
      }
    />
  );
}
